import { Position } from '@xyflow/react';
import { ERFElement } from '../../../enums';
import { L_FLOW_HEX, M_FLOW_HEX } from '../../../constants';
export const SEPARATOR_2PH_CONFIG = {
    type: ERFElement.Separator2ph,
    icon: 'Separator_2ph_2d',
    templates: [
        {
            code: 'default',
            ports: [
                {
                    id: 'target_material_flow',
                    type: 'target',
                    name: 'Входной поток',
                    position: Position.Left,
                    style: { top: 80, left: 7, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                {
                    id: 'source_material_gas_flow',
                    type: 'source',
                    name: 'Выходной поток газа',
                    position: Position.Top,
                    style: { top: 7, left: 32, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                {
                    id: 'source_material_liquid_flow',
                    type: 'source',
                    name: 'Выходной поток жидкости',
                    position: Position.Bottom,
                    style: { bottom: 7, left: 32, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                /* PORTS FOR LOGICAL ELEMENTS */
                {
                    id: 'target_logical_flow',
                    type: 'target',
                    name: 'Входные параметры',
                    position: Position.Left,
                    style: { top: 115, left: 7, background: L_FLOW_HEX },
                    connectionCount: Number.MAX_SAFE_INTEGER
                },
                {
                    id: 'source_logical_flow',
                    type: 'source',
                    name: 'Выходные параметры',
                    position: Position.Right,
                    style: { top: 115, right: 51, background: L_FLOW_HEX },
                    connectionCount: Number.MAX_SAFE_INTEGER
                }
            ]
        }
    ]
};
//# sourceMappingURL=RFSeparator2phNode.config.js.map